import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Grid, Card, Button, Icon} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {inputFields, dropdownFields} from '../static/commonStructures';
import EditOrclonePartNumberCodeTable from './table';
import './editClonePnc.scss';

const DATA_FIELDS = inputFields.concat(dropdownFields);

class EditOrclonePartNumberCode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'tableValues': [],
      'disableSaveButton': true,
    };
    this.handleSaveClick = this.handleSaveClick.bind(this);
    this.handleCancelClick = this.handleCancelClick.bind(this);
    this.handleTableValuesState = this.handleTableValuesState.bind(this);
  }

  componentDidMount() {
    if (!this.props.location.state) {
      return null;
    }
    const {pncInfo} = this.props.location.state;
    const pncInfoArray = this.formatInfo(pncInfo);
    this.setState({'tableValues': [[...pncInfoArray]]});
    this.props.getPncByCode(pncInfoArray[0]);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.tableValues !== this.state.tableValues) {
      const {tableValues} = this.state;

      tableValues.some((row) => {
        this.setState({'disableSaveButton': this.isRowInvalid(row)});
        return this.isRowInvalid(row);
      });
    }
  }

  handleTableValuesState(updatedTableValues) {
    this.setState({'tableValues': updatedTableValues});
  }

  handleCancelClick() {
    this.props.goBack();
  }

  async handleSaveClick() {
    const {editPnc} = this.props.location.state;
    const {code} = this.props.code;
    const {tableValues} = this.state;
    if (!editPnc) {
      await this.props.savePncInformation(tableValues);
    } else {
      await this.props.editPncInformation(code, tableValues);
    }
    this.props.goBack();
  }

  isRowInvalid(row) {
    return !row[0] || !row[1] || !row[4] || !row[9];
  }

  formatInfo(pncInfo) {
    const englishNames = DATA_FIELDS.map((fieldDetail) => {
      return fieldDetail.englishName;
    });
    return englishNames.map((fieldName) => pncInfo[fieldName] || '');
  }

  renderTitleAndActions() {
    const {disableSaveButton} = this.state;
    const {loading} = this.props;
    const {editPnc} = this.props.location.state;
    return (
      <Card raised fluid className='title-bar'>
        <Grid>
          <Grid.Row verticalAlign='top'>
            <Icon name='arrow left' onClick={this.handleCancelClick} disabled={loading}/>
            <Grid.Column width={11} textAlign='left'>
              <h2>{editPnc ? 'Editar' : 'Clonar'} PNC</h2>
            </Grid.Column>
            <Grid.Column width={2}>
              <Button onClick={this.handleCancelClick} disabled={loading} secondary>
                Cancelar
              </Button>
            </Grid.Column>
            <Grid.Column width={2}>
              <Button
                primary
                onClick={this.handleSaveClick}
                className='save-button'
                disabled={disableSaveButton}
                loading={loading}
              >
                Guardar
              </Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Card>
    );
  }

  render() {
    const {tableValues} = this.state;
    const {location} = this.props;

    if (!location.state) {
      return null;
    }
  
    return (
      <div className='pnc-clone-edit'>
        {this.renderTitleAndActions()}
        <Card fluid raised>
          <div className='horizontal-scroll'>
            <EditOrclonePartNumberCodeTable
              handleTableValuesState={this.handleTableValuesState}
              tableValues={tableValues}
              location={location}
            />
          </div>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    'goBack': ownProps.history.goBack,
    'code': ownProps.params,
    'location': ownProps.history.location,
    'loading': state.partNumberCodeInstance.loading,
  };
};

const {
  savePncInformation,
  editPncInformation,
  getPncByCode,
  withRouter,
} = Actions;

export default withRouter(connect(mapStateToProps, {
  savePncInformation,
  editPncInformation,
  getPncByCode,
})(EditOrclonePartNumberCode));
